import { lazy } from 'react';

import type { RouteConfig } from '../../types';

// Lazy load layouts
const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const InvoiceLayout = lazy(() => import('@/pages/invoices/layout'));
const InvoiceDetailsLayout = lazy(() => import('@/pages/invoices/[invoiceId]/layout'));

// Lazy load invoice pages
const InvoicesPage = lazy(() => import('@/pages/invoices'));
const CreateInvoicePage = lazy(() => import('@/pages/invoices/create'));
const InvoiceDetailsPage = lazy(() => import('@/pages/invoices/[invoiceId]/details/invoice'));
const CreditMemoDetailsPage = lazy(() => import('@/pages/invoices/[invoiceId]/details/creditMemo'));

const InvoiceMobileOverviewPage = lazy(() => import('@/pages/invoices/[invoiceId]/details/overview'));
const InvoiceMobileItemsPage = lazy(() => import('@/pages/invoices/[invoiceId]/details/items'));
const InvoiceMobileHistoryPage = lazy(() => import('@/pages/invoices/[invoiceId]/details/history'));
const InvoiceMobileCommentsPage = lazy(() => import('@/pages/invoices/[invoiceId]/details/comments'));
const InvoiceMobileCreditMemoReasonPage = lazy(() => import('@/pages/invoices/[invoiceId]/details/creditMemoReason'));

/**
 * Invoice routes
 * Handles invoice management
 */
export const invoiceRoutes: RouteConfig = {
  path: '/invoices',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: InvoiceLayout,
      element: InvoicesPage,
    },
    {
      path: '/create',
      layout: InvoiceLayout,
      element: CreateInvoicePage,
    },
    {
      path: '/:invoiceId',
      layout: InvoiceDetailsLayout,
      children: [
        {
          path: '/details/invoice',
          element: InvoiceDetailsPage,
        },
        {
          path: '/details/creditMemo',
          element: CreditMemoDetailsPage,
        },
        {
          path: '/details/overview',
          element: InvoiceMobileOverviewPage,
        },
        {
          path: '/details/creditMemoReason',
          element: InvoiceMobileCreditMemoReasonPage,
        },
        {
          path: '/details/items',
          element: InvoiceMobileItemsPage,
        },
        {
          path: '/details/history',
          element: InvoiceMobileHistoryPage,
        },
        {
          path: '/details/comments',
          element: InvoiceMobileCommentsPage,
        },
      ],
    },
  ],
};
